export const VIEW_JQL_BUILDER_ADVANCED_EXPERIENCE_NAME = 'viewJqlBuilderAdvanced';
export const PACKAGE_NAME = 'jiraJqlBuilderAdvanced';
export const TEAM_NAME = 'empanada';
